module.exports = __webpack_public_path__ + "img/Leader+svartvit.09b1c060.jpg";